import Box from '~/common/mui/Layout/Box';

type BoxProps = React.ComponentProps<typeof Box>;

const ModalBody = ({ children, sx, ...props }: Readonly<BoxProps>) => {
  return (
    <Box
      className="mui-modal-body"
      sx={{
        px: 6,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default ModalBody;
